import React, { lazy, Suspense, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AddEmployee from "../feature/employee/AddEmployee";
import EmployeeList from "../feature/employee/EmployeeList";
import AddCategory from "../feature/masterModule/category/AddCategory";
import ArchivedCategoryList from "../feature/masterModule/category/ArchivedCategoryList";
import CategoryList from "../feature/masterModule/category/CategoryList";
import AddMaterial from "../feature/masterModule/materialMaster/AddMaterial";
import ArchivedMaterialList from "../feature/masterModule/materialMaster/ArchivedMaterialList";
import MaterialList from "../feature/masterModule/materialMaster/MaterialList";
import AddMaterialType from "../feature/masterModule/materialType/AddMaterialType";
import MaterialTypeList from "../feature/masterModule/materialType/MaterialTypeList";
import PincodeList from "../feature/masterModule/pincode/PincodeList";
import ZoneList from "../feature/masterModule/zone/ZoneList";
import MyCompany from "../feature/mycompany/MyCompany";
import ArchivedRequestedDemoList from "../feature/requestedDemo/ArchivedRequestedDemoList";
import RequestedDemoList from "../feature/requestedDemo/RequestedDemoList";
import AddSuperUserRole from "../feature/superUser/AddSuperUserRole";
import SuperUserRoleList from "../feature/superUser/SuperUserRoleList";
import AddSuperUser from "../feature/superUser/AddSuperUser";
import SuperUserList from "../feature/superUser/SuperUserList";
import AddUserRole from "../feature/userRole/AddUserRole";
import UserRoleList from "../feature/userRole/UserRoleList";
import AddVendor from "../feature/vendor/AddVendor";
import VendorList from "../feature/vendor/VendorList";
import { authUserData, SpinLoading } from "../utils/Helper";

import ActivityLogList from "../feature/activityLog/ActivityLogList";
import ArchiveActivityLog from "../feature/activityLog/ArchiveActivityLog";
import AddDocuments from "../feature/companydocuments/AddDocuments";
import ArchiveCompanyDocuments from "../feature/companydocuments/ArchiveCompanyDocuments";
import CompanyDocumentsList from "../feature/companydocuments/CompanyDocumentsList";
import AddCompanyOnboarding from "../feature/companyOnboarding/AddCompanyOnboarding";
import ArchivecompanyOnboarding from "../feature/companyOnboarding/ArchiveCompanyOnboarding";
import CompanyOnboardingList from "../feature/companyOnboarding/CompanyOnboardingList";
import CompanyAddressList from "../feature/deliveryAddress/CompanyAddressList";
import ArchivedEmployeeList from "../feature/employee/ArchivedEmployeeList";
import ArchivedSuperUserList from "../feature/superUser/ArchivedSuperUserList";
import AddHierarchy from "../feature/hierarchy/AddHierarchy";
import ArchivedCommercialInvoiceList from "../feature/invoice/commercial/ArchivedCommercialInvoiceList";
import CommercialInvoice from "../feature/invoice/commercial/CommercialInvoice";
import CommercialInvoiceList from "../feature/invoice/commercial/CommercialInvoiceList";
import ArchivedPerformaInvoiceList from "../feature/invoice/performa/ArchivedPerformaInvoiceList";
import PerformaInvoice from "../feature/invoice/performa/PerformaInvoice";
import PerformaInvoiceList from "../feature/invoice/performa/PerformaInvoiceList";
import ArchivedMaterialTypeList from "../feature/masterModule/materialType/ArchivedMaterialTypeList";
import ArchivedPincodeList from "../feature/masterModule/pincode/ArchivedPincodeList";
import ArchivedUnitOfMeasurement from "../feature/masterModule/unitOfMeasurement/ArchivedUnitOfMeasurement";
import UnitOfMeasurement from "../feature/masterModule/unitOfMeasurement/UnitOfMeasurement";
import ArchiveZoneList from "../feature/masterModule/zone/ArchiveZoneList";
import MyVendor from "../feature/mycompany/MyVendor";
import MyOrder from "../feature/myOrder/MyOrder";
import Newsletter from "../feature/newsletter/Newsletter";
import ArchivedPurchaseRequisition from "../feature/PR/ArchivedPurchaseRequisition";
import AddPurchasedSubscription from "../feature/subscription/purchasedSubscription/AddPurchasedSubscription";
import ArchivedpurchasedSubscriptionList from "../feature/subscription/purchasedSubscription/ArchivedPurchasedSubscriptionList";
import PurchasedSubscriptionList from "../feature/subscription/purchasedSubscription/PurchasedSubscriptionList";
import AddSubscription from "../feature/subscription/subscriptionMaster/AddSubscription";
import ArchivedSubscriptionList from "../feature/subscription/subscriptionMaster/ArchivedSubscriptionList";
import SubscriptionList from "../feature/subscription/subscriptionMaster/SubscriptionList";
import ArchivedVendorList from "../feature/vendor/ArchivedVendorList";
import AddAddress from "./../feature/deliveryAddress/AddAddress";
import ArchiveDeliveryList from "./../feature/deliveryAddress/ArchiveDeliveryList";
import NotAccess from "./NotAccess";

import PaymentSuccessfully from "../authentication/PaymentSuccessfully";
import CategoryItemSetting from "../feature/categoryItemSetting/CategoryItemSetting";
import CategoryItemSettingList from "../feature/categoryItemSetting/CategoryItemSettingList";
import ArchivedCompanyDocument from "../feature/companyOnboarding/ArchivedCompanyDocument";
import ArchiveSectoeList from "../feature/masterModule/sector/ArchiveSectorList";
import SectorList from "../feature/masterModule/sector/SectorList";
import AddNewPurchaseRequisition from "../feature/PR/AddNewPurchaseRequisition";
import AssignPurchaseRequisition from "../feature/PR/AssignPurchaseRequisition";
import AssignPurchaseRequisitionDetails from "../feature/PR/AssignPurchaseRequisitionDetails";
import PurchaseRequisitionDetails from "../feature/PR/PurchaseRequisitionDetails";
import PurchaseRequisitionHistory from "../feature/PR/PurchaseRequisitionHistory";
import GeneralProcurementList from "../feature/generalProcurement/GeneralProcurementList";
import GeneralProcurementEntry from "../feature/generalProcurement/GeneralProcurementEntry";
import ArchivedGeneralProcurementList from "../feature/generalProcurement/ArchivedGeneralProcurementList";
import GeneralProcurementComparative from "../feature/generalProcurement/GeneralProcurementComparative";
import GeneralProcurementSummaryPriceComparative from "../feature/generalProcurement/GeneralProcurementSummaryPriceComparative";
import GeneralProcurementPreviewAndSendApproval from "../feature/generalProcurement/GeneralProcurementPreviewAndSendApproval";
import GeneralPurchaseOrderSummary from "../feature/generalProcurement/GeneralPurchaseOrderSummary";
import VendorGeneralPurchaseOrderSummary from "../feature/generalProcurement/vendor/VendorGeneralPurchaseOrderSummary";
import ArchivePRApprovalHierarchy from "../feature/prApprovalHierarchy/ArchivePRApprovalHierarchy";
import PRApprovalHierarchy from "../feature/prApprovalHierarchy/PRApprovalHierarchy";
import PRApprovalHierarchyList from "../feature/prApprovalHierarchy/PRApprovalHierarchyList";
import AddNewRFQ from "../feature/requestForQuotation/AddNewRFQ";
import AddRFQ from "../feature/requestForQuotation/AddRFQ";
import FloatRFQAssignPR from "../feature/requestForQuotation/FloatRFQAssignPR";
import RFQHistory from "../feature/requestForQuotation/RFQHistory";
import RFQMaterialDetails from "../feature/requestForQuotation/RFQMaterialDetails";
import SelectVendor from "../feature/requestForQuotation/SelectVendor";
import ArchiveUserRoleList from "../feature/userRole/ArchiveUserRoleList";
import ArchiveSuperUserRoleList from "../feature/superUser/ArchiveSuperUserRoleList";
import ArchiveAssignSite from "../feature/vendor/ArchiveAssignSite";
import ArchivedVendorDocument from "../feature/vendor/ArchivedVendorDocument";
import VendorAssignRequestForQuotation from "../feature/vendorRFQ/VendorAssignRequestForQuotation";
import VendorRequestForQuotation from "../feature/vendorRFQ/VendorRequestForQuotation";
import VendorRFQHistory from "../feature/vendorRFQ/VendorRFQHistory";
import VendorRFQMaterialDetails from "../feature/vendorRFQ/VendorRFQMaterialDetails";
import ArchivedAdminCompanyDocument from "../feature/companyOnboarding/ArchivedAdminCompanyDocument";
import FloatRFQPurchaseRequisitionAssignDetails from "../feature/PR/FloatRFQPurchaseRequisitionAssignDetails";
import PRApprovalButton from "../feature/PR/PRApprovalButton";
import AddNewAssignRFQ from "../feature/requestForQuotation/AddNewAssignRFQ";
import ArchiveFloatRFQAssignPR from "../feature/requestForQuotation/ArchiveFloatRFQAssignPR";
import ArchiveRFQHistoryCompany from "../feature/requestForQuotation/ArchiveRFQHistoryCompany";
import EmailForNotificationRFQ from "../feature/requestForQuotation/EmailForNotificationRFQ";
import MaterialWiseComparatives from "../feature/requestForQuotation/MaterialWiseComparatives";
import RFQApprovalPage from "../feature/requestForQuotation/RFQApprovalPage";
import SummaryPriceComparativeStatement from "../feature/requestForQuotation/SummaryPriceComparativeStatement";
import PurchaseOrderSummary from "../feature/vendor/PurchaseOrderSummary";
import ArchiveAssignRequestForQuotation from "../feature/vendorRFQ/ArchiveAssignRequestForQuotation";
import ArchiveRFQHistory from "../feature/vendorRFQ/ArchiveRFQHistory";
import VendorBidRFQ from "../feature/vendorRFQ/VendorBidRFQ";
import VendorBidRFQView from "../feature/vendorRFQ/VendorBidRFQView";
// import Comparatives from "../feature/requestForQuotation/Comparatives";
import EmailPRApproval from "../authentication/EmailPRApproval";
import EmailRFQApproval from "../authentication/EmailRFQApproval";
import { GetToken } from "../authentication/GetToken";
import LoginWithEmailOtp from "../authentication/LoginWithEmailOtp";
import AddMaterialCompany from "../feature/companyMaterialMaster/AddMaterialCompany";
import ArchivedMaterialListCompany from "../feature/companyMaterialMaster/ArchivedMaterialListCompany";
import MaterialListCompany from "../feature/companyMaterialMaster/MaterialListCompany";
import PurchaseOrder1 from "../feature/po/PurchaseOrder1";
import PurchaseOrder2 from "../feature/po/PurchaseOrder2";
import PurchaseOrderView from "../feature/po/PurchaseOrderView";
import PurchaseOrderBySite from "../feature/po/PurchaseOrderBySite";
import NewPR from "../feature/PR/NewPR";
import OrderApproval from "../feature/PurchaseOrder/OrderApproval";
import PreviewSendForApproval from "../feature/PurchaseOrder/PreviewSendForApproval";
import OrderIssueReport from "../feature/reports/OrderIssueReport";
import PriceTrandReport from "../feature/reports/PriceTrandReport";
import SiteWiseOrderReport from "../feature/reports/SiteWiseOrderReport";
import VendorOrderReport from "../feature/reports/VendorOrderReport";
import PurchaseOrderSpendAnalysisReport from "../feature/reports/PurchaseOrderSpendAnalysisReport";
import RfqPoConversionReport from "../feature/reports/RfqPoConversionReport";
import ApproveRFQ from "../feature/requestForQuotation/ApproveRFQ";
import ApproveRFQView from "../feature/requestForQuotation/ApproveRFQView";
import PreviewAndSendApproval from "../feature/requestForQuotation/PreviewAndSendApproval";
import SiteWiseComparatives from "../feature/requestForQuotation/SiteWiseComparatives";
import VendorPurchaseOrderSummary from "../feature/vendorRFQ/VendorPurchaseOrderSummary";
// import Step3 from "../authentication/steps/step3";
import AddManageUserGroupStep from "../authentication/steps/AddManageUserGroupStep";
import AddManageUserStep from "../authentication/steps/AddManageUserStep";
import AddPrReleaseHierarchyStep from "../authentication/steps/AddPrReleaseHierarchyStep";
import AddSiteLocationStep from "../authentication/steps/AddSiteLocationStep";
import AddVendorOnboardingStep from "../authentication/steps/AddVendorOnboardingStep";
import Supports from "../authentication/Supports";
import VendorNewBisRFQCityWise from "../feature/vendorRFQ/VendorNewBidRFQCityWise";
import ComparativeSiteWise from "../feature/requestForQuotation/ComparativeSiteWise";
import ViewNewVendorBidRFQ from "../feature/vendorRFQ/ViewNewVendorBidRFQ";
import ViewVendorBidStageRFQ from "../feature/vendorRFQ/ViewVendorBidStageRFQ";
import VendorViewRFQBidDetail from "../feature/vendorRFQ/VendorViewRFQBidDetail";
import EmailPRApprovalNew from "../authentication/EmailPRApprovalNew";
import PoOrderApprovalRejection from "../authentication/PoOrderApprovalRejection";
import SendForApprovalMyForm from "../authentication/SendForApprovalMyForm";
import PurchaseOrderMyForm from "../authentication/PurchaseOrderMyForm";
import VendorPurchaseSummary from "../feature/vendor/VendorPurchaseSummary";
import VendorPoApproveReject from "../feature/requestForQuotation/VendorPoApproveReject";
import ViewRFQDetails from "../feature/PR/ViewRFQDetails";
import NewAddPR from "../feature/NewPrMaterial/NewAddPR";
import CreateNewPR from "../feature/NewPrMaterial/CreateNewPR";
import SubCategoryList from "../feature/masterModule/subcategory/SubCategoryList";
import AddSubCategory from "../feature/masterModule/subcategory/AddSubCategory";
import ArchivedSubCategoryList from "../feature/masterModule/subcategory/ArchivedSubCategoryList";
import ArchivedVendorDocumentStape from "../authentication/steps/ArchivedVendorDocumentStep";
import PurchaseSubscription from "../feature/conciergeService/PurchaseSubscription";
import PaymentSuccessPage from "../feature/conciergeService/PaymentSuccessPage";
import SubscriptionPurchaseOrder from "../feature/conciergeService/SubscriptionPurchaseOrder";
import UserProfile from "../feature/mycompany/UserProfile";
import ViewRFQVendor from "../authentication/ViewRFQVendor";
import Commercialinvoicepdf from "../feature/conciergeService/Commercialinvoicepdf";
import SiteWiseMaterialCompany from "../feature/companyMaterialMaster/SIteWiseMaterialCompany";
import EditMaterial from "../feature/deliveryAddress/EditMaterial";
import NewPRReinforcementSteel from "../feature/NewPrMaterial/NewPRReinforcementSteel";
import EditMaterialStep from "../feature/deliveryAddress/EditMaterialStep";
import CategorySelectionForRFQ from "../feature/requestForQuotation/CategorySelectionForRFQ";
import CityWiseVendorSelection from "../feature/requestForQuotation/CitywiseVendorSelection";
import VendorBidRFQSteel from "../feature/vendorRFQ/VendorBidRFQSteel";
import ViewNewVendorBidRFQSteel from "../feature/vendorRFQ/ViewNewVendorBidRFQSteel";
import ComparativeSiteDiameterWise from "../feature/requestForQuotation/ComparativeSiteDiameterWise";
import SummaryPriceComparativeByDiameter from "../feature/requestForQuotation/SummaryPriceComparativeByDiameter";
import PreviewAndSendApprovalDiameterWise from "../feature/requestForQuotation/PreviewAndSendApprovalDiameterWise";
import MaterialWiseComparativeByDiameter from "../feature/requestForQuotation/MaterialWiseComparativeByDiameter";
import VendorListSuperAdmin from "../feature/vendor/VendorListSuperAdmin";
import AddVendorSuperAdmin from "../feature/vendor/AddVendorSuperAdmin";
import ArchivedSuperAdminVendorList from "../feature/vendor/ArchivedSuperAdminVendorList";
import Vendorlogin from "../authentication/Vendorlogin";
import InventoryItemReturnEntry from "../feature/Inventory/returnReplacement/InventoryItemReturnEntry";
import QuarantinedMaterialQueue from "../feature/Inventory/returnReplacement/QuarantinedMaterialQueue";
import ReturnQuarantinedMaterial from "../feature/Inventory/returnReplacement/ReturnQuarantinedMaterial";
import ReturnRequestsList from "../feature/Inventory/returnReplacement/ReturnRequestsList";
import ReturnAuthorizationDetail from "../feature/Inventory/returnReplacement/ReturnAuthorizationDetail";
import TrackShipment from "../feature/Inventory/returnReplacement/TrackShipment";
import ProcurementHubReturnReplacementPlanning from "../feature/Inventory/returnReplacement/ProcurementHubReturnReplacementPlanning";
import ReportModule from "../feature/Inventory/analytics/ReportModule";
import SupplierReplacementDasbhoard from "../feature/Inventory/SupplierReplacementCycle/SupplierReplacementDasbhoard";
import SupplierAcknowledgeReturn from "../feature/Inventory/SupplierReplacementCycle/SupplierAcknowledgeReturn";
import ProjectStructure from "../feature/Inventory/MaterialIndent/ProjectStructure";
import UnitMaterialStandardBOM from "../feature/Inventory/MaterialIndent/UnitMaterialStandardBOM";
import IndentRequests from "../feature/Inventory/MaterialIndent/IndentRequests";
import AllProjects from "../feature/Inventory/MaterialIndent/AllProjects";
import PhysicalInventoryVerification from "../feature/Inventory/MaterialIndent/PhysicalInventoryVerification";
import PhysicalMaterialVarianceSummary from "../feature/Inventory/MaterialIndent/PhysicalMaterialVarianceSummary";
import TabwiseDocument from "../feature/Inventory/TabwiseDocument";
import SiteWiseReport from "../feature/Inventory/SiteWiseReport";
import CentralStore from "../feature/deliveryAddress/CentralStore";
import GeneralVendorList from "../feature/generalProcurement/GeneralVendorList";
import GeneralVendorAdd from "../feature/generalProcurement/GeneralVendorAdd";
import VendorGeneralRFQHistory from "../feature/generalProcurement/vendor/VendorGeneralRFQHistory";
import ArchiveGeneralRFQHistory from "../feature/generalProcurement/vendor/ArchiveGeneralRFQHistory";
import VendorBidGeneralRFQ from "../feature/generalProcurement/vendor/VendorBidGeneralRFQ";
import VendorViewGeneralRFQ from "../feature/generalProcurement/vendor/VendorViewGeneralRFQ";
import GeneralPurchaseOrder from "../feature/po/GeneralPurchaseOrder";
const Login = lazy(() => import("../authentication/Login"));
const Register = lazy(() => import("../authentication/Register"));
const VerifyOtp = lazy(() => import("../authentication/VerifyOtp"));
const VerifySuccess = lazy(() => import("../authentication/VerifySuccess"));
const VerifyAccount = lazy(() => import("../authentication/VerifyAccount"));
const ForgotSuccess = lazy(() => import("../authentication/ForgotSuccess"));
const ForgotPassword = lazy(() => import("../authentication/ForgotPassword"));
const ResetPassword = lazy(() => import("../authentication/ResetPassword"));
const ApprovalForPR = lazy(() => import("../authentication/ApprovalForPR"));
const EmailGeneralRFQApproval = lazy(() =>
  import("../authentication/EmailGeneralRFQApproval"),
);
const EmailGeneralPOApproval = lazy(() =>
  import("../authentication/EmailGeneralPOApproval"),
);
const EmailGeneralPOVendorApproval = lazy(() =>
  import("../authentication/EmailGeneralPOVendorApproval"),
);
const PasswordSuccess = lazy(() => import("../authentication/PasswordSuccess"));
const RegisterSuccess = lazy(() => import("../authentication/RegisterSuccess"));
const SupportSuccess = lazy(() => import("../authentication/SupportSuccess"));
const RequestSuccess = lazy(() => import("../authentication/RequestSuccess"));
const MaterialMasterStep = lazy(
  () => import("../authentication/steps/MaterialMasterStep"),
);
const SiteLocationStep = lazy(
  () => import("../authentication/steps/SiteLocationStep"),
);
const PrReleaseHierarchyStep = lazy(
  () => import("../authentication/steps/PrReleaseHierarchyStep"),
);
const BusinessSettingStep = lazy(
  () => import("../authentication/steps/BusinessSettingStep"),
);
const VendorOnboardingStep = lazy(
  () => import("../authentication/steps/VendorOnboardingStep"),
);
const ManageUserStep = lazy(
  () => import("../authentication/steps/ManageUserStep"),
);
const ManageUserGroupStep = lazy(
  () => import("../authentication/steps/ManageUserGroupStep"),
);
const Step2Add = lazy(
  () => import("../authentication/steps/AddSiteLocationStep"),
);
const Step7Add = lazy(
  () => import("../authentication/steps/AddVendorOnboardingStep"),
);
const Step4Edit = lazy(
  () => import("../authentication/steps/AddManageUserStep"),
);
const Step5Edit = lazy(
  () => import("../authentication/steps/AddPrReleaseHierarchyStep"),
);
const Step3Add = lazy(
  () => import("../authentication/steps/AddManageUserGroupStep"),
);
const Logout = lazy(() => import("../authentication/Logout"));
const CompanyDetail = lazy(
  () => import("../authentication/companyDetail/CompanyDetail"),
);
const Dashboard = lazy(() => import("../feature/dashboard/Dashboard"));
const InventoryDashboard = lazy(
  () => import("../feature/Inventory/inventory_dashboard/InventoryDashboard"),
);

const ManageTicket = lazy(() => import("../feature/ticket/ManageTicket"));
const CreateTicket = lazy(() => import("../feature/ticket/CreateTicket"));

const PurchasedConcierge = lazy(
  () => import("../feature/subscription/PurchasedConcierge"),
);

const ManageConciergeService = lazy(
  () => import("../feature/subscription/ManageConciergeService"),
);
const RequestConciergeList = lazy(
  () => import("../feature/subscription/RequestedConcierge"),
);
const AddConciergeService = lazy(
  () => import("../feature/subscription/AddConciergeService"),
);
const ConciergeService = lazy(
  () => import("../feature/conciergeService/ConciergeService"),
);
const PaymentSuccess = lazy(
  () => import("../feature/conciergeService/PaymentSuccess"),
);
const PaymentFailure = lazy(
  () => import("../feature/conciergeService/PaymentFailure"),
);

const PrivateRoute = lazy(() => import("./PrivateRoute"));
const TermsCondition = lazy(() => import("../authentication/TermsCondition"));
const EditProfile = lazy(() => import("../feature/profile/EditProfile"));
const UserList = lazy(() => import("../feature/user/UserList"));
const AddUser = lazy(() => import("../feature/user/AddUser"));
const Settings = lazy(() => import("../feature/settings/settings"));
const LoginWithOtp = lazy(() => import("../authentication/LoginWithOtp"));
const MyForm = lazy(() => import("../authentication/MyForm"));

const Root = () => {
  const [pageLoaded, setPageLoaded] = useState(
    () => document.readyState !== "loading",
  );
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const authToken = GetToken();
    return Boolean(authToken);
  });
  const token = GetToken();

  useEffect(() => {
    const token = GetToken();
    if (token && !isAuthenticated) {
      setIsAuthenticated(true);
    }
  }, [isAuthenticated]);
  const isCompanyAdmin = authUserData()?.role?.some(
    (role) => role.name === "Company Admin",
  );
  const hasCompanyRole = authUserData()?.company_role === "Company Admin";

  const keepMe = authUserData()?.keep_me_logged_in;
  // const companyAdmin = authUserData()?.role[0].name === "Company Admin";
  const companyAdmin = authUserData()?.role?.some((role) =>
    role.name.includes("Company Admin"),
  );

  // const superAdmin = authUserData()?.role[0].name === "Super Admin";
  const superAdmin = authUserData()?.role?.some((role) =>
    role.name.includes("Super Admin"),
  );
  const VendorAdmin = authUserData()?.role?.some((role) =>
    role.name.includes("Vendor Admin"),
  );
  const employeeLogin = authUserData()?.company
    ? authUserData()?.role[0]?.name.includes("company_")
    : null;

  const company = authUserData()?.company_role === "Company Admin";

  const companyPercentage = authUserData()?.company_profile_perc || 0;

  useEffect(() => {
    const handleLoad = () => {
      setPageLoaded(true);
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", handleLoad);
    } else {
      handleLoad();
    }

    return () => {
      document.removeEventListener("DOMContentLoaded", handleLoad);
    };
  }, []);
  return (
    <>
      {pageLoaded && isAuthenticated ? (
        <Suspense fallback={<SpinLoading />}>
          <Routes>
            <>
              {isAuthenticated && keepMe ? (
                companyPercentage >= 100 && companyAdmin ? (
                  <Route
                    element={
                      <Suspense fallback={<SpinLoading />}>
                        <Dashboard />
                      </Suspense>
                    }
                  />
                ) : superAdmin || VendorAdmin ? (
                  <Route
                    element={
                      <Suspense fallback={<SpinLoading />}>
                        <Dashboard />
                      </Suspense>
                    }
                  />
                ) : (
                  <Route
                    path="/"
                    element={
                      <Suspense fallback={<SpinLoading />}>
                        <Login />
                      </Suspense>
                    }
                  />
                )
              ) : (
                <Route
                  path="/"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <Login />
                    </Suspense>
                  }
                />
              )}

              <Route
                path="/login"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <Login />
                  </Suspense>
                }
              />

              <Route
                path="/payment-successfully"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <PaymentSuccessfully />
                  </Suspense>
                }
              />
              <Route
                path="/login-with-whatsApp-otp"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <LoginWithOtp />
                  </Suspense>
                }
              />
              <Route
                path="/pdfdownload-purchase-requisition/details/pdf/:id"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <MyForm />
                  </Suspense>
                }
              />
              <Route
                path="/pdfdownload-preview-send-for-approval/details/pdf/:id"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <SendForApprovalMyForm />
                  </Suspense>
                }
              />
              <Route
                path="/pdfdownload-purchase-order/pdf/:id"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <PurchaseOrderMyForm />
                  </Suspense>
                }
              />
              <Route
                path="/pdfdownload-purchase-order-details/pdf/:id/:vendorId"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    {/* <PODetailsMyForm /> */}
                    <PurchaseOrder1 />
                  </Suspense>
                }
              />
              <Route
                path="/pdfdownload-general-purchase-order-details/pdf/:id/:vendorId"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <GeneralPurchaseOrder />
                  </Suspense>
                }
              />
              <Route
                path="payment-subscription-pdf/:id/:companyId"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <SubscriptionPurchaseOrder />
                  </Suspense>
                }
              />
              <Route
                path="commercial-invoice-pdf/:id"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <Commercialinvoicepdf />
                  </Suspense>
                }
              />
              <Route
                path="/purchase-order/:id/view/:siteName"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <PurchaseOrderBySite />
                  </Suspense>
                }
              />
              <Route
                path="/login-with-email-otp"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <LoginWithEmailOtp />
                  </Suspense>
                }
              />
              <Route
                path="/company-registration"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <Register />
                  </Suspense>
                }
              />
              <Route
                path="/supports"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <Supports />
                  </Suspense>
                }
              />
              <Route
                path="/terms-condition"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <TermsCondition />
                  </Suspense>
                }
              />

              <Route
                path="/reset-password/:resetToken"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <ResetPassword />
                  </Suspense>
                }
              />

              <Route
                path="/purchase-requisition/pr-approve-by-email/:resetToken/:id/:prType/?action=Approve"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <ApprovalForPR />
                  </Suspense>
                }
              />
              <Route
                path="/purchase-requisition/pr-approval/:resetToken/:id"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <PRApprovalButton />
                  </Suspense>
                }
              />
              <Route
                path="/purchase-requisition/pr-approve-by-email/:resetToken/:comId/:id/:prType"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <EmailPRApprovalNew />
                  </Suspense>
                }
              />
              <Route
                path="/bid-rfq/:id/bid-rfq-city-wise-of-whatsapp/"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <ViewVendorBidStageRFQ />
                  </Suspense>
                }
              />
              <Route
                path="float-rfq/rfq-approval/:resetToken/:id/"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <EmailRFQApproval />
                  </Suspense>
                }
              />
              <Route
                path="general-rfqs/rfq-approval/:resetToken/:id"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <EmailGeneralRFQApproval />
                  </Suspense>
                }
              />
              <Route
                path="general-rfqs/rfq-approval/:resetToken/:id/"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <EmailGeneralRFQApproval />
                  </Suspense>
                }
              />
              <Route
                path="general-purchase-order/po-approval/:token/:id"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <EmailGeneralPOApproval />
                  </Suspense>
                }
              />
              <Route
                path="general-purchase-order/po-approval/:token/:id/"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <EmailGeneralPOApproval />
                  </Suspense>
                }
              />
              <Route
                path="general-po-order/po-approval-by-vendor/:token/:id"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <EmailGeneralPOVendorApproval />
                  </Suspense>
                }
              />
              <Route
                path="general-po-order/po-approval-by-vendor/:token/:id/"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <EmailGeneralPOVendorApproval />
                  </Suspense>
                }
              />
              <Route
                path="float-rfq/vendor-rfq-detail-view/:id/"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <ViewRFQVendor />
                  </Suspense>
                }
              />

              <Route
                path="/purchase-order/po-approval/:token/:id/"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <ApproveRFQ />
                  </Suspense>
                }
              />

              <Route
                path="/po-order/purchase-order-approval/:token/:id/"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <ApproveRFQ />
                  </Suspense>
                }
              />
              <Route
                path="/po-order/:id/po-copy-to-po-alloted-vendor"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <PurchaseOrderView />
                  </Suspense>
                }
              />
              <Route
                path="/po-order/po-approval-by-vendor/:token/:id"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <VendorPoApproveReject />
                  </Suspense>
                }
              />
              <Route
                path="/bid-rfq/:id/get-bid-rfq-city-wise/"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <VendorViewRFQBidDetail />
                  </Suspense>
                }
              />
              <Route
                path="/purchase-requisition/pr-approve-by-email/:resetToken/:comId/:id/:prType"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <EmailPRApprovalNew />
                  </Suspense>
                }
              />
              <Route
                path="float-rfq/rfq-approval/:resetToken/:id/:rfqNumber"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <EmailRFQApproval />
                  </Suspense>
                }
              />

              <Route
                path="float-rfq/vendor-rfq-detail-view/:id/"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <ViewRFQVendor />
                  </Suspense>
                }
              />

              <Route
                path="/po-order/:id/po-copy-to-pr-rfq-approval"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <ApproveRFQView />
                  </Suspense>
                }
              />
              <Route
                path="/po-order/:id/po-copy-to-po-alloted-vendor"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <PurchaseOrderView />
                  </Suspense>
                }
              />
              <Route
                path="/forgot-password"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <ForgotPassword />
                  </Suspense>
                }
              />
              <Route
                path="/mail-sent"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <ForgotSuccess />
                  </Suspense>
                }
              />

              <Route
                path="/support-success"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <SupportSuccess />
                  </Suspense>
                }
              />
              <Route
                path="/password-success"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <PasswordSuccess />
                  </Suspense>
                }
              />
              <Route
                path="/verify-success"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <VerifySuccess />
                  </Suspense>
                }
              />
              <Route
                path="/register-success"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <RegisterSuccess />
                  </Suspense>
                }
              />
              <Route
                path="/request-success"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <RequestSuccess />
                  </Suspense>
                }
              />
              <Route
                path="/verify-account"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <VerifyAccount />
                  </Suspense>
                }
              />
              <Route
                path="/verify/:mode/:id"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <VerifyOtp />
                  </Suspense>
                }
              />
              <Route
                path="/logout"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <Logout />
                  </Suspense>
                }
              />
              <Route path="/company-detail/:id" element={<CompanyDetail />} />

              <Route
                exact
                path="/"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <PrivateRoute />
                  </Suspense>
                }
              >
                <Route
                  path="/dashboard"
                  element={
                    isAuthenticated ? <Dashboard /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/inventory-dashboard"
                  element={
                    isAuthenticated ? (
                      <InventoryDashboard />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/inventory-scan-and-acceptance"
                  element={
                    isAuthenticated ? <TabwiseDocument /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/inventory-site-wise-report"
                  element={
                    isAuthenticated ? <SiteWiseReport /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/inventory-return-entry"
                  element={
                    isAuthenticated ? (
                      <InventoryItemReturnEntry />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />


                <Route
                  path="/return-requests-list"
                  element={
                    isAuthenticated ? (
                      <ReturnRequestsList />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/return-authorization-detail/:id?"
                  element={
                    isAuthenticated ? (
                      <ReturnAuthorizationDetail />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/inventory-supplier-replacement-cycle"
                  element={
                    isAuthenticated ? <TrackShipment /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/track-shipment"
                  element={
                    isAuthenticated ? <TrackShipment /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/procurement-hub-return-replacement-planning/:id"
                  element={
                    isAuthenticated ? (
                      <ProcurementHubReturnReplacementPlanning />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/inventory-quarantined-material-queue"
                  element={
                    isAuthenticated ? (
                      <QuarantinedMaterialQueue />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/return-quarantined-material/:id?"
                  element={
                    isAuthenticated ? (
                      <ReturnQuarantinedMaterial />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/supplier-return-replacement-dashboard"
                  element={
                    isAuthenticated ? (
                      <SupplierReplacementDasbhoard />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/supplier-acknowledge-return"
                  element={
                    isAuthenticated ? (
                      <SupplierAcknowledgeReturn />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/general-procurement-list"
                  element={
                    isAuthenticated ? (
                      <GeneralProcurementList />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/general-vendor-list"
                  element={
                    isAuthenticated ? (
                      <GeneralVendorList />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/general-vendor/add"
                  element={
                    isAuthenticated ? (
                      <GeneralVendorAdd />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/general-vendor/edit/:id"
                  element={
                    isAuthenticated ? (
                      <GeneralVendorAdd />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/general-procurement/add"
                  element={
                    isAuthenticated ? (
                      <GeneralProcurementEntry />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/general-procurement/edit/:id"
                  element={
                    isAuthenticated ? (
                      <GeneralProcurementEntry />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/general-procurement/history/archive"
                  element={
                    isAuthenticated ? (
                      <ArchivedGeneralProcurementList />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/general-procurement/comparative/:id"
                  element={
                    isAuthenticated ? (
                      <GeneralProcurementComparative />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/general-procurement/summarypricecomparatives/:id"
                  element={
                    isAuthenticated ? (
                      <GeneralProcurementSummaryPriceComparative />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/general-procurement/previewandsendapproval/:id"
                  element={
                    isAuthenticated ? (
                      <GeneralProcurementPreviewAndSendApproval />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/general-purchase-order-summary"
                  element={
                    isAuthenticated ? (
                      <GeneralPurchaseOrderSummary />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/project-structure"
                  element={
                    isAuthenticated ? <ProjectStructure /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/unit-material-standard"
                  element={
                    isAuthenticated ? (
                      <UnitMaterialStandardBOM />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/indent-requests"
                  element={
                    isAuthenticated ? <IndentRequests /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/projects"
                  element={
                    isAuthenticated ? <AllProjects /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/physical-inventory-verification"
                  element={
                    isAuthenticated ? (
                      <PhysicalInventoryVerification />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/physical-material-variance-summary"
                  element={
                    isAuthenticated ? (
                      <PhysicalMaterialVarianceSummary />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/inventory-report"
                  element={
                    isAuthenticated ? <ReportModule /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/payment-success"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <PaymentSuccess />
                    </Suspense>
                  }
                />
                <Route
                  path="/payment-failure"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <PaymentFailure />
                    </Suspense>
                  }
                />
                <Route path="/my-vendor" element={<MyVendor />} />
                <Route path="/my-company" element={<MyCompany />} />
                <Route path="/user-profile" element={<UserProfile />} />
                <Route path="/my-company/:companyId" element={<MyCompany />} />
                <Route
                  path="/my-profile"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <EditProfile />
                    </Suspense>
                  }
                />
                <Route
                  path="/my-order"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <MyOrder />
                    </Suspense>
                  }
                />
                <Route
                  path="/settings"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <Settings />
                    </Suspense>
                  }
                />
                <Route path="/create-ticket" element={<CreateTicket />} />
                <Route path="/manage-ticket" element={<ManageTicket />} />
                {/* <Route
                  path="/concierge-service"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ConciergeService />
                    </Suspense>
                  }
                /> */}
                <Route
                  path="/manage-concierge-service"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ManageConciergeService />
                    </Suspense>
                  }
                />
                <Route
                  path="/manage-concierge-service/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddConciergeService />
                    </Suspense>
                  }
                />
                <Route
                  path="/manage-concierge-service/edit/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddConciergeService />
                    </Suspense>
                  }
                />
                <Route
                  path="/purchased-concierge-service"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <PurchasedConcierge />
                    </Suspense>
                  }
                />
                <Route
                  path="/request-for-price"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <RequestConciergeList />
                    </Suspense>
                  }
                />
                <Route
                  path="/subscription"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <SubscriptionList />
                    </Suspense>
                  }
                />
                <Route
                  path="/subscription/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddSubscription />
                    </Suspense>
                  }
                />
                <Route
                  path="/subscription/edit/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddSubscription />
                    </Suspense>
                  }
                />
                <Route
                  path="/subscription/archived"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchivedSubscriptionList />
                    </Suspense>
                  }
                />
                <Route
                  path="/purchased-subscription"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <PurchasedSubscriptionList />
                    </Suspense>
                  }
                />
                <Route
                  path="/purchased-subscription/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddPurchasedSubscription />
                    </Suspense>
                  }
                />
                <Route
                  path="/purchased-subscription/edit/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddPurchasedSubscription />
                    </Suspense>
                  }
                />
                <Route
                  path="/purchased-subscription/archived"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchivedpurchasedSubscriptionList />
                    </Suspense>
                  }
                />
                <Route
                  path="/user"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <UserList />
                    </Suspense>
                  }
                />
                <Route
                  path="/user/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddUser />
                    </Suspense>
                  }
                />
                <Route
                  path="/user/edit/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddUser />
                    </Suspense>
                  }
                />
                <Route
                  path="/superuser-role"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <SuperUserRoleList />
                    </Suspense>
                  }
                />
                <Route
                  path="/superuser-role/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddSuperUserRole />
                    </Suspense>
                  }
                />
                <Route
                  path="/superuser-role/edit/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddSuperUserRole />
                    </Suspense>
                  }
                />
                <Route
                  path="/superuser-role/archive"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchiveSuperUserRoleList />
                    </Suspense>
                  }
                />

                <Route
                  path="/user-role"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <UserRoleList />
                    </Suspense>
                  }
                />
                <Route
                  path="/user-role/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddUserRole />
                    </Suspense>
                  }
                />
                <Route
                  path="/user-role/edit/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddUserRole />
                    </Suspense>
                  }
                />
                <Route
                  path="/user-role/archive"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchiveUserRoleList />
                    </Suspense>
                  }
                />
                <Route
                  path="/company-documents"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <CompanyDocumentsList />
                    </Suspense>
                  }
                />
                <Route
                  path="/company-documents/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddDocuments />
                    </Suspense>
                  }
                />
                <Route
                  path="/company-documents/archive"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchiveCompanyDocuments />
                    </Suspense>
                  }
                />
                <Route
                  path="/company-documents/edit/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddDocuments />
                    </Suspense>
                  }
                />

                <Route
                  path="/superuser"
                  element={
                    isAuthenticated ? <SuperUserList /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/superuser/add"
                  element={
                    isAuthenticated ? <AddSuperUser /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/superuser/edit/:id"
                  element={
                    isAuthenticated ? <AddSuperUser /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/superuser/archive"
                  element={
                    isAuthenticated ? (
                      <ArchivedSuperUserList />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/employee"
                  element={
                    isAuthenticated ? <EmployeeList /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/employee/add"
                  element={
                    isAuthenticated ? <AddEmployee /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/employee/edit/:id"
                  element={
                    isAuthenticated ? <AddEmployee /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/employee/archive"
                  element={
                    isAuthenticated ? (
                      <ArchivedEmployeeList />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/zone"
                  element={superAdmin ? <ZoneList /> : <Navigate to="/" />}
                />
                <Route
                  path="/archive-zone-list"
                  element={
                    superAdmin ? <ArchiveZoneList /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/pincode"
                  element={superAdmin ? <PincodeList /> : <Navigate to="/" />}
                />

                <Route
                  path="/pincode/archive"
                  element={
                    superAdmin ? <ArchivedPincodeList /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/sector"
                  element={superAdmin ? <SectorList /> : <Navigate to="/" />}
                />

                <Route
                  path="/sector/archive"
                  element={
                    superAdmin ? <ArchiveSectoeList /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/category"
                  element={superAdmin ? <CategoryList /> : <Navigate to="/" />}
                />

                <Route
                  path="/category/add"
                  element={superAdmin ? <AddCategory /> : <Navigate to="/" />}
                />
                <Route
                  path="/category/edit/:id"
                  element={superAdmin ? <AddCategory /> : <Navigate to="/" />}
                />
                <Route
                  path="/category/archive"
                  element={
                    superAdmin ? <ArchivedCategoryList /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/sub-category"
                  element={
                    superAdmin ? <SubCategoryList /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/sub-category/add"
                  element={
                    superAdmin ? <AddSubCategory /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/sub-category/edit/:id"
                  element={
                    superAdmin ? <AddSubCategory /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/sub-category/archive"
                  element={
                    superAdmin ? (
                      <ArchivedSubCategoryList />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/unit-of-measurement"
                  element={
                    superAdmin ? <UnitOfMeasurement /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/unit-of-measurement/archive"
                  element={
                    superAdmin ? (
                      <ArchivedUnitOfMeasurement />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/material"
                  element={superAdmin ? <MaterialList /> : <Navigate to="/" />}
                />

                <Route
                  path="/material/add"
                  element={superAdmin ? <AddMaterial /> : <Navigate to="/" />}
                />
                <Route
                  path="/material/edit/:id"
                  element={superAdmin ? <AddMaterial /> : <Navigate to="/" />}
                />
                <Route
                  path="/material/archive"
                  element={
                    superAdmin ? <ArchivedMaterialList /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/company-material"
                  element={
                    companyAdmin ? <MaterialListCompany /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/company-material-sitewise"
                  element={
                    companyAdmin ? (
                      <SiteWiseMaterialCompany />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/company-material/add"
                  element={
                    companyAdmin ? <AddMaterialCompany /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/company-material/edit/:id"
                  element={
                    companyAdmin ? <AddMaterialCompany /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/company-material/archive"
                  element={
                    companyAdmin ? (
                      <ArchivedMaterialListCompany />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/material-type"
                  element={
                    superAdmin ? <MaterialTypeList /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/material-type/add"
                  element={
                    superAdmin ? <AddMaterialType /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/material-type/edit/:id"
                  element={
                    superAdmin ? <AddMaterialType /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/material-type/archive"
                  element={
                    superAdmin ? (
                      <ArchivedMaterialTypeList />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/vendor"
                  element={companyAdmin ? <VendorList /> : <Navigate to="/" />}
                />
                <Route
                  path="/vendor/add"
                  element={companyAdmin ? <AddVendor /> : <Navigate to="/" />}
                />
                <Route
                  path="/vendor/edit/:id"
                  element={companyAdmin ? <AddVendor /> : <Navigate to="/" />}
                />
                <Route
                  path="/vendor/archive"
                  element={
                    companyAdmin ? <ArchivedVendorList /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/vendor-document/archive/:id"
                  element={
                    companyAdmin || VendorAdmin ? (
                      <ArchivedVendorDocument />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/vendor-assign-site/archive"
                  element={
                    companyAdmin ? <ArchiveAssignSite /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/vendor-superadmin"
                  element={
                    superAdmin ? <VendorListSuperAdmin /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/vendor-superadmin/add"
                  element={
                    superAdmin ? <AddVendorSuperAdmin /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/vendor-superadmin/edit/:id"
                  element={
                    superAdmin ? <AddVendorSuperAdmin /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/vendor-superadmin/archive"
                  element={
                    superAdmin ? (
                      <ArchivedSuperAdminVendorList />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/purchase-requisition"
                  element={
                    employeeLogin && companyAdmin ? (
                      <AddNewPurchaseRequisition />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                {/* <Route
                  path="/purchase-requisition/sites/:id"
                  element={
                    employeeLogin || companyAdmin ? (
                      <NewPR />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                /> */}
                <Route
                  path="/purchase-requisition/sites/new/:id"
                  element={
                    authUserData()?.permission.includes(
                      "purchase_requisition|add_purchaserequisitionmaster",
                    ) && !isCompanyAdmin ? (
                      <NewAddPR />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/create-pr"
                  element={
                    authUserData()?.permission.includes(
                      "purchase_requisition|add_purchaserequisitionmaster",
                    ) && !isCompanyAdmin ? (
                      <CreateNewPR />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/assign-pr"
                  element={
                    authUserData()?.permission.includes("rfq|add_floatrfq") &&
                    !isCompanyAdmin ? (
                      <CategorySelectionForRFQ />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/select-category"
                  element={
                    authUserData()?.vendor_role === "Vendor Admin" &&
                    !isCompanyAdmin ? (
                      <CategorySelectionForRFQ />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/purchase-requisition/sites/new/2"
                  element={
                    authUserData()?.permission.includes(
                      "purchase_requisition|add_purchaserequisitionmaster",
                    ) && !isCompanyAdmin ? (
                      <NewPRReinforcementSteel />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/purchase-requisition/sites/:id/:prId"
                  element={
                    employeeLogin || companyAdmin ? (
                      <NewPR />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/purchase-requisition/details/:id"
                  element={
                    employeeLogin || companyAdmin ? (
                      <PurchaseRequisitionDetails />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/request-for-quotation-view/:responseId"
                  element={
                    employeeLogin || companyAdmin ? (
                      <ViewRFQDetails />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/purchase-requisition-history"
                  element={
                    // authUserData()?.group_permission?.includes(
                    authUserData()?.permission?.includes(
                      "purchase_requisition|view_purchaserequisitionmaster",
                    ) ? (
                      <PurchaseRequisitionHistory />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
              
                <Route
                  path="/purchase-requisition/sites/:id"
                  element={
                    employeeLogin || companyAdmin ? (
                      <NewPR />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/purchase-requisition/archive"
                  element={
                    employeeLogin || companyAdmin ? (
                      <ArchivedPurchaseRequisition />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/purchase-requisition-assign/:id"
                  element={
                    employeeLogin || companyAdmin ? (
                      <AssignPurchaseRequisition />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/purchase-requisition-assign-details/:id/:categoryId"
                  element={
                    employeeLogin || companyAdmin ? (
                      <AssignPurchaseRequisitionDetails />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/float-rfq-purchase-requisition-assign-details/:id"
                  element={
                    employeeLogin || companyAdmin ? (
                      <FloatRFQPurchaseRequisitionAssignDetails />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/request-for-quotation/add"
                  element={
                    employeeLogin || companyAdmin ? (
                      <AddNewRFQ />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/request-for-quotation/history/archive"
                  element={
                    employeeLogin || companyAdmin ? (
                      <ArchiveRFQHistoryCompany />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/purchased-subscriptions"
                  element={
                    isAuthenticated &&
                    companyPercentage >= 100 &&
                    companyAdmin ? (
                      <Suspense fallback={<SpinLoading />}>
                        <PurchaseSubscription />
                      </Suspense>
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/request-for-quotation/comparatives/:id"
                  element={
                    employeeLogin || companyAdmin ? (
                      <SiteWiseComparatives />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/request-for-quotation/comparatives-by-city/:id"
                  element={
                    employeeLogin || companyAdmin ? (
                      <ComparativeSiteWise />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/request-for-quotation/comparatives-by-city-by-diameter/:id"
                  element={
                    employeeLogin || companyAdmin ? (
                      <ComparativeSiteDiameterWise />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/verifyotp"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <VerifyOtp />
                    </Suspense>
                  }
                />

                <Route
                  path="/request-for-quotation/summarypricecomparatives/:id"
                  element={
                    authUserData()?.permission.includes(
                      "rfq|change_poorder",
                    ) ? (
                      <SummaryPriceComparativeStatement />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/request-for-quotation/summarypricecomparatives-by-diameter/:id"
                  element={
                    authUserData()?.permission.includes(
                      "rfq|change_poorder",
                    ) ? (
                      <SummaryPriceComparativeByDiameter />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/request-for-quotation/previewandsendapproval/:id"
                  element={
                    authUserData()?.permission.includes(
                      "rfq|change_poorder",
                    ) ? (
                      <PreviewAndSendApproval />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/request-for-quotation/previewandsendapproval-by-diameter/:id"
                  element={
                    authUserData()?.permission.includes(
                      "rfq|change_poorder",
                    ) ? (
                      <PreviewAndSendApprovalDiameterWise />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/request-for-quotation/approve-purchase-order/"
                  element={companyAdmin ? <ApproveRFQ /> : <Navigate to="/" />}
                />

                <Route
                  path="/vendor-purchase-order-summary/"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <VendorPurchaseOrderSummary />
                    </Suspense>
                  }
                />

                <Route
                  path="/vendor-general-purchase-order-summary"
                  element={
                    isAuthenticated ? (
                      <Suspense fallback={<SpinLoading />}>
                        <VendorGeneralPurchaseOrderSummary />
                      </Suspense>
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/vendor-general-purchase-order-summary/"
                  element={
                    isAuthenticated ? (
                      <Suspense fallback={<SpinLoading />}>
                        <VendorGeneralPurchaseOrderSummary />
                      </Suspense>
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/purchase-order-one/"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <PurchaseOrder1 />
                    </Suspense>
                  }
                />
                <Route
                  path="/subscription-purchase-order/"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <SubscriptionPurchaseOrder />
                    </Suspense>
                  }
                />
                <Route
                  path="/purchase-order-two/"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <PurchaseOrder2 />
                    </Suspense>
                  }
                />

                <Route
                  path="/request-for-quotation/assign-rfq"
                  element={
                    employeeLogin || companyAdmin ? (
                      <AddNewAssignRFQ />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/request-for-quotation/purchase-order-summary"
                  element={
                    authUserData()?.permission.includes(
                      "rfq|change_poorder",
                    ) ? (
                      <PurchaseOrderSummary />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/vendor-purchase-order-summary"
                  element={
                    VendorAdmin ? (
                      <VendorPurchaseSummary />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/request-for-quotation/float-rfq-assign-pr/:id"
                  element={
                    companyAdmin || employeeLogin ? (
                      <FloatRFQAssignPR />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/request-for-quotation/float-rfq-assign-pr/archive/:id"
                  element={
                    companyAdmin || employeeLogin ? (
                      <ArchiveFloatRFQAssignPR />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/request-for-quotation/history"
                  element={
                    companyAdmin || employeeLogin ? (
                      <RFQHistory />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/request-for-quotation/add-rfq/:responseId"
                  element={
                    companyAdmin || employeeLogin ? (
                      <AddRFQ />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/request-for-quotation/rfq-material-details/:responseId"
                  element={
                    companyAdmin || employeeLogin ? (
                      <RFQMaterialDetails />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/request-for-quotation/rfq-material-details-steel/:responseId"
                  element={
                    companyAdmin || employeeLogin ? (
                      <CityWiseVendorSelection />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/request-for-quotation/select-vendor/:rfqId"
                  element={
                    companyAdmin || employeeLogin ? (
                      <SelectVendor />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/request-for-quotation/material-wise-comparatives/:id"
                  element={
                    companyAdmin || employeeLogin ? (
                      <MaterialWiseComparatives />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/request-for-quotation/material-wise-comparatives-by-diameter/:id"
                  element={
                    companyAdmin || employeeLogin ? (
                      <MaterialWiseComparativeByDiameter />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/request-for-quotation/email-notification/:rfqDetailFloatID/:rfqId"
                  element={
                    companyAdmin || employeeLogin ? (
                      <EmailForNotificationRFQ />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/request-for-quotation/rfq-approval/:rfqId"
                  element={
                    companyAdmin || employeeLogin ? (
                      <RFQApprovalPage />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/vendor-request-for-quotation"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <VendorRequestForQuotation />
                    </Suspense>
                  }
                />
                <Route
                  path="/vendor-request-for-quotation/assign"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <VendorAssignRequestForQuotation />
                    </Suspense>
                  }
                />
                <Route
                  path="/vendor-request-for-quotation/assign/archive"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchiveAssignRequestForQuotation />
                    </Suspense>
                  }
                />
                <Route
                  path="/rfq-vendor-request-for-quotation/history/:id"
                  element={
                    VendorAdmin ? (
                      <Suspense fallback={<SpinLoading />}>
                        <VendorRFQHistory />
                      </Suspense>
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/rfq-vendor-general-request-for-quotation/history/1"
                  element={
                    VendorAdmin ? (
                      <Suspense fallback={<SpinLoading />}>
                        <VendorGeneralRFQHistory />
                      </Suspense>
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/rfq-vendor-general-request-for-quotation/history/archive/"
                  element={
                    VendorAdmin ? (
                      <Suspense fallback={<SpinLoading />}>
                        <ArchiveGeneralRFQHistory />
                      </Suspense>
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/rfq-vendor-request-for-quotation/view-bid-rfq/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <VendorBidRFQView />
                    </Suspense>
                  }
                />
                <Route
                  path="/rfq-vendor-request-for-quotation/new-view-bid-rfq/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ViewNewVendorBidRFQ />
                    </Suspense>
                  }
                />
                <Route
                  path="/rfq-vendor-request-for-quotation/new-view-bid-rfq-steel/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ViewNewVendorBidRFQSteel />
                    </Suspense>
                  }
                />
                <Route
                  path="/bid-rfq/:id/bid-rfq-city-wise-of-whatsapp/"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ViewVendorBidStageRFQ />
                    </Suspense>
                  }
                />
                <Route
                  path="/rfq-vendor-request-for-quotation/history/archive/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchiveRFQHistory />
                    </Suspense>
                  }
                />

                <Route
                  path="/rfq-vendor-request-for-quotation/bid-rfq/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <VendorBidRFQ />
                    </Suspense>
                  }
                />
                <Route
                  path="/rfq-vendor-request-for-quotation-city-wise/bid-rfq/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <VendorNewBisRFQCityWise />
                    </Suspense>
                  }
                />
                <Route
                  path="/general-rfq-vendor-request-for-quotation/bid-rfq/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <VendorBidGeneralRFQ />
                    </Suspense>
                  }
                />
                <Route
                  path="/general-rfq-vendor-request-for-quotation/view-rfq/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <VendorViewGeneralRFQ />
                    </Suspense>
                  }
                />
                <Route
                  path="/rfq-vendor-request-for-quotation-city-wise/bid-rfq-steel/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <VendorBidRFQSteel />
                    </Suspense>
                  }
                />
                <Route
                  path="/summary"
                  element={
                    <Suspense fallback={<PreviewSendForApproval />}>
                      <OrderApproval />
                    </Suspense>
                  }
                />
                <Route
                  path="/vendor-request-for-quotation/Material-details/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <VendorRFQMaterialDetails />
                    </Suspense>
                  }
                />
                <Route
                  path="/newsletter"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <Newsletter />
                    </Suspense>
                  }
                />
                <Route
                  path="/requested-demo"
                  element={
                    superAdmin ? (
                      <Suspense fallback={<SpinLoading />}>
                        <RequestedDemoList />
                      </Suspense>
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/requested-demo/archive"
                  element={
                    superAdmin ? (
                      <ArchivedRequestedDemoList />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/request-for-quotation/PreviewSendForApproval"
                  element={
                    companyAdmin || employeeLogin ? (
                      <PreviewSendForApproval />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/company-onboarding"
                  element={
                    superAdmin ? <CompanyOnboardingList /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/company-onboarding/add"
                  element={
                    superAdmin ? <AddCompanyOnboarding /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/company-onboarding/edit/:id"
                  element={
                    superAdmin ? <AddCompanyOnboarding /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/company-onboarding/archive"
                  element={
                    superAdmin ? (
                      <ArchivecompanyOnboarding />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/company-onboarding-document/archive"
                  element={
                    superAdmin || companyAdmin ? (
                      <ArchivedCompanyDocument />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/archived-admin-company-onboarding-document/archive/:id"
                  element={
                    superAdmin ? (
                      <ArchivedAdminCompanyDocument />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/delivery-address"
                  element={
                    companyAdmin ? <CompanyAddressList /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/delivery-address/add"
                  element={companyAdmin ? <AddAddress /> : <Navigate to="/" />}
                />

                <Route
                  path="/delivery-address/archive"
                  element={
                    companyAdmin ? <ArchiveDeliveryList /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/delivery-address/edit/:id"
                  element={companyAdmin ? <AddAddress /> : <Navigate to="/" />}
                />
                <Route
                  path="/delivery-address/central-store/add"
                  element={
                    companyAdmin ? <CentralStore /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/delivery-address/central-store/edit/:id"
                  element={
                    companyAdmin ? <CentralStore /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/delivery-address-material/edit/:id"
                  element={
                    companyAdmin ? <EditMaterial /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/reports/order-issue-report"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <OrderIssueReport />
                    </Suspense>
                  }
                />
                <Route
                  path="/reports/vendor-order-report"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <VendorOrderReport />
                    </Suspense>
                  }
                />
                <Route
                  path="/reports/site-wise-order-report"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <SiteWiseOrderReport />
                    </Suspense>
                  }
                />
                <Route
                  path="/reports/price-trand-report"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <PriceTrandReport />
                    </Suspense>
                  }
                />
                <Route
                  path="/reports/po-spend-analysis-report"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <PurchaseOrderSpendAnalysisReport />
                    </Suspense>
                  }
                />
                <Route
                  path="/subscription-list"
                  element={
                    companyAdmin ? (
                      <Suspense fallback={<SpinLoading />}>
                        <ConciergeService />
                      </Suspense>
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="reports/rfq-po-conversion-report"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <RfqPoConversionReport />
                    </Suspense>
                  }
                />
                <Route
                  path="/activity-log"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ActivityLogList />
                    </Suspense>
                  }
                />
                <Route
                  path="/activity-log/archive"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchiveActivityLog />
                    </Suspense>
                  }
                />
                <Route
                  path="/hierarchy"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddHierarchy />
                    </Suspense>
                  }
                />
                <Route
                  path="/performa-invoice"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <PerformaInvoiceList />
                    </Suspense>
                  }
                />
                <Route
                  path="/performa-invoice/archive"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchivedPerformaInvoiceList />
                    </Suspense>
                  }
                />
                <Route
                  path="/performa-invoice/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <PerformaInvoice />
                    </Suspense>
                  }
                />
                <Route
                  path="/performa-invoice/edit/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <PerformaInvoice />
                    </Suspense>
                  }
                />
                <Route
                  path="/commercial-invoice"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <CommercialInvoiceList />
                    </Suspense>
                  }
                />
                <Route
                  path="/commercial-invoice/archive"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchivedCommercialInvoiceList />
                    </Suspense>
                  }
                />
                <Route
                  path="/commercial-invoice/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <CommercialInvoice />
                    </Suspense>
                  }
                />
                <Route
                  path="/commercial-invoice/edit/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <CommercialInvoice />
                    </Suspense>
                  }
                />
                <Route
                  path="/not-access"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <NotAccess />
                    </Suspense>
                  }
                />

                <Route
                  path="/company-category-item-setting/edit/:id"
                  element={
                    companyAdmin ? <CategoryItemSetting /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/category-item-setting"
                  element={
                    companyAdmin ? (
                      <CategoryItemSettingList />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/pr-approval-heirarchy"
                  element={
                    companyAdmin ? <PRApprovalHierarchy /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="pr-approval-heirarchy-list"
                  element={
                    companyAdmin ? (
                      <PRApprovalHierarchyList />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/pr-approval-heirarchy/edit/:id"
                  element={
                    companyAdmin ? <PRApprovalHierarchy /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/pr-approval-heirarchy/archive"
                  element={
                    companyAdmin ? (
                      <ArchivePRApprovalHierarchy />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
              </Route>

              <Route
                path="/material-master-step"
                element={
                  isAuthenticated &&
                  authUserData()?.company_profile_perc < 100 &&
                  companyAdmin ? (
                    <Suspense fallback={<SpinLoading />}>
                      <MaterialMasterStep />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                path="/site-location-step"
                element={
                  isAuthenticated && companyPercentage < 100 && companyAdmin ? (
                    <Suspense fallback={<SpinLoading />}>
                      <SiteLocationStep />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route
                path="/site-location-step/add"
                element={
                  isAuthenticated && companyPercentage < 100 && companyAdmin ? (
                    <Suspense fallback={<SpinLoading />}>
                      <AddSiteLocationStep />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route
                path="/site-location-step/edit/:id"
                element={
                  isAuthenticated && companyPercentage < 100 && companyAdmin ? (
                    <Suspense fallback={<SpinLoading />}>
                      <AddSiteLocationStep />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route
                path="/user-manage-group-step"
                element={
                  isAuthenticated && companyPercentage < 100 && companyAdmin ? (
                    <Suspense fallback={<SpinLoading />}>
                      <ManageUserGroupStep />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route
                path="/user-manage-group-step/add"
                element={
                  isAuthenticated && companyPercentage < 100 && companyAdmin ? (
                    <Suspense fallback={<SpinLoading />}>
                      <AddManageUserGroupStep />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route
                path="/user-manage-group-step/edit/:id"
                element={
                  isAuthenticated && companyPercentage < 100 && companyAdmin ? (
                    <Suspense fallback={<SpinLoading />}>
                      <AddManageUserGroupStep />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route
                path="/delivery-address-material-step/edit/:id"
                element={
                  isAuthenticated && companyPercentage < 100 && companyAdmin ? (
                    <Suspense fallback={<SpinLoading />}>
                      <EditMaterialStep />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route
                path="/manage-user-step"
                element={
                  isAuthenticated && companyPercentage < 100 && companyAdmin ? (
                    <Suspense fallback={<SpinLoading />}>
                      <ManageUserStep />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route
                path="/manage-user-step/add"
                element={
                  isAuthenticated && companyPercentage < 100 && companyAdmin ? (
                    <AddManageUserStep />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route
                path="/manage-user-step/edit/:id"
                element={
                  isAuthenticated && companyPercentage < 100 && companyAdmin ? (
                    <Suspense fallback={<SpinLoading />}>
                      <AddManageUserStep />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route
                path="/pr-release-hierarchy-step"
                element={
                  isAuthenticated && companyPercentage < 100 && companyAdmin ? (
                    <Suspense fallback={<SpinLoading />}>
                      <PrReleaseHierarchyStep />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route
                path="/pr-release-hierarchy-step/add"
                element={
                  isAuthenticated && companyPercentage < 100 && companyAdmin ? (
                    <Suspense fallback={<SpinLoading />}>
                      <AddPrReleaseHierarchyStep />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route
                path="/pr-release-hierarchy-step/edit/:id"
                element={
                  isAuthenticated && companyPercentage < 100 && companyAdmin ? (
                    <Suspense fallback={<SpinLoading />}>
                      <AddPrReleaseHierarchyStep />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route
                path="/business-setting-step"
                element={
                  isAuthenticated && companyPercentage < 100 && companyAdmin ? (
                    <Suspense fallback={<SpinLoading />}>
                      <BusinessSettingStep />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route
                path="payment-subscription/"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <PaymentSuccessPage />
                  </Suspense>
                }
              />

              <Route
                path="/vendor-onboarding-step"
                element={
                  isAuthenticated && companyPercentage < 100 && companyAdmin ? (
                    <Suspense fallback={<SpinLoading />}>
                      <VendorOnboardingStep />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route
                path="/vendor-onboarding-step/add"
                element={
                  isAuthenticated && companyPercentage < 100 && companyAdmin ? (
                    <Suspense fallback={<SpinLoading />}>
                      <AddVendorOnboardingStep />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route
                path="/vendor-document-step/archive/:id"
                element={
                  companyAdmin || VendorAdmin ? (
                    <ArchivedVendorDocumentStape />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route
                path="/vendor-onboarding-step/edit/:id"
                element={
                  isAuthenticated && companyPercentage < 100 && companyAdmin ? (
                    <Suspense fallback={<SpinLoading />}>
                      <AddVendorOnboardingStep />
                    </Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                path="/stepthreeadd"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <Step3Add />
                  </Suspense>
                }
              />
            </>
          </Routes>
        </Suspense>
      ) : (
        <Routes>
          <Route
            path="*"
            element={
              <Suspense fallback={<SpinLoading />}>
                <Login />
              </Suspense>
            }
          />
          <Route
            path="/login-with-email-otp"
            element={
              <Suspense fallback={<SpinLoading />}>
                <LoginWithEmailOtp />
              </Suspense>
            }
          />
          <Route
            path="/login-with-whatsApp-otp"
            element={
              <Suspense fallback={<SpinLoading />}>
                <LoginWithOtp />
              </Suspense>
            }
          />
          <Route
            path="/purchase-requisition/details/pdf/:id"
            element={
              <Suspense fallback={<SpinLoading />}>
                <MyForm />
              </Suspense>
            }
          />
          <Route
            path="/reset-password/:resetToken"
            element={
              <Suspense fallback={<SpinLoading />}>
                <ResetPassword />
              </Suspense>
            }
          />
          <Route
            path="/purchase-requisition/pr-approve-by-email/:resetToken/:id/:prType/?action=Approve"
            element={
              <Suspense fallback={<SpinLoading />}>
                <ApprovalForPR />
              </Suspense>
            }
          />
          <Route
            path="/purchase-requisition/pr-approval/:resetToken/:id"
            element={
              <Suspense fallback={<SpinLoading />}>
                <PRApprovalButton />
              </Suspense>
            }
          />
          <Route
            path="float-rfq/rfq-approval/:resetToken/:id/"
            element={
              <Suspense fallback={<SpinLoading />}>
                <EmailRFQApproval />
              </Suspense>
            }
          />
          <Route
            path="general-rfqs/rfq-approval/:resetToken/:id"
            element={
              <Suspense fallback={<SpinLoading />}>
                <EmailGeneralRFQApproval />
              </Suspense>
            }
          />
          <Route
            path="general-rfqs/rfq-approval/:resetToken/:id/"
            element={
              <Suspense fallback={<SpinLoading />}>
                <EmailGeneralRFQApproval />
              </Suspense>
            }
          />
          <Route
            path="general-purchase-order/po-approval/:token/:id"
            element={
              <Suspense fallback={<SpinLoading />}>
                <EmailGeneralPOApproval />
              </Suspense>
            }
          />
          <Route
            path="general-purchase-order/po-approval/:token/:id/"
            element={
              <Suspense fallback={<SpinLoading />}>
                <EmailGeneralPOApproval />
              </Suspense>
            }
          />
          <Route
            path="general-po-order/po-approval-by-vendor/:token/:id"
            element={
              <Suspense fallback={<SpinLoading />}>
                <EmailGeneralPOVendorApproval />
              </Suspense>
            }
          />
          <Route
            path="general-po-order/po-approval-by-vendor/:token/:id/"
            element={
              <Suspense fallback={<SpinLoading />}>
                <EmailGeneralPOVendorApproval />
              </Suspense>
            }
          />
          <Route
            path="float-rfq/vendor-rfq-detail-view/:id/"
            element={
              <Suspense fallback={<SpinLoading />}>
                <ViewRFQVendor />
              </Suspense>
            }
          />

          <Route
            path="/purchase-order/po-approval/:token/:id/"
            element={
              employeeLogin || companyAdmin ? null : (
                <Suspense fallback={<SpinLoading />}>
                  <ApproveRFQ />
                </Suspense>
              )
            }
          />
          <Route
            path="/po-order/purchase-order-approval/:token/:id/"
            element={
              <Suspense fallback={<SpinLoading />}>
                <ApproveRFQ />
              </Suspense>
            }
          />
          <Route
            path="/po-order/:id/po-copy-to-pr-rfq-approval"
            element={
              <Suspense fallback={<SpinLoading />}>
                <ApproveRFQView />
              </Suspense>
            }
          />
          <Route
            path="/bid-rfq/:id/bid-rfq-city-wise-of-whatsapp/"
            element={
              <Suspense fallback={<SpinLoading />}>
                <ViewVendorBidStageRFQ />
              </Suspense>
            }
          />
          <Route
            path="/purchase-requisition/pr-approve-by-email/:resetToken/:id/:prType/?action=Approve"
            element={
              <Suspense fallback={<SpinLoading />}>
                <ApprovalForPR />
              </Suspense>
            }
          />
          <Route
            path="/pdfdownload-purchase-order-details/pdf/:id/:vendorId"
            element={
              <Suspense fallback={<SpinLoading />}>
                <PurchaseOrder1 />
              </Suspense>
            }
          />
          <Route
            path="/pdfdownload-general-purchase-order-details/pdf/:id/:vendorId"
            element={
              <Suspense fallback={<SpinLoading />}>
                <GeneralPurchaseOrder />
              </Suspense>
            }
          />
          <Route
            path="payment-subscription-pdf/:id/:companyId"
            element={
              <Suspense fallback={<SpinLoading />}>
                <SubscriptionPurchaseOrder />
              </Suspense>
            }
          />
          <Route
            path="/purchase-requisition/pr-approve-by-email/:resetToken/:comId/:id/:prType"
            element={
              <Suspense fallback={<SpinLoading />}>
                <EmailPRApprovalNew />
              </Suspense>
            }
          />
          <Route
            path="/po-order/:id/po-copy-to-po-alloted-vendor"
            element={
              <Suspense fallback={<SpinLoading />}>
                <PurchaseOrderView />
              </Suspense>
            }
          />
          {/* <Route
            path="/po-order/po-approval-by-vendor/:token/:id"
            element={
              !employeeLogin || !companyAdmin ? 
              (<Suspense fallback={<SpinLoading />}>
                <VendorPoApproveReject />
              </Suspense>) 
              : ""
            }
          /> */}
          <Route
            path="/vendor-registration"
            element={
              <Suspense fallback={<SpinLoading />}>
                <Vendorlogin />
              </Suspense>
            }
          />
          <Route
            path="/po-order/po-approval-by-vendor/:token/:id"
            element={
              <Suspense fallback={<SpinLoading />}>
                <VendorPoApproveReject />
              </Suspense>
            }
          />

          <Route
            path="/bid-rfq/:id/get-bid-rfq-city-wise/"
            element={
              <Suspense fallback={<SpinLoading />}>
                <VendorViewRFQBidDetail />
              </Suspense>
            }
          />
          <Route
            path="/purchase-requisition/pr-approve-by-email/:resetToken/:comId/:id/:prType"
            element={
              <Suspense fallback={<SpinLoading />}>
                <EmailPRApprovalNew />
              </Suspense>
            }
          />
          <Route
            path="float-rfq/rfq-approval/:resetToken/:id/:rfqNumber"
            element={
              <Suspense fallback={<SpinLoading />}>
                <EmailRFQApproval />
              </Suspense>
            }
          />
          <Route
            path="float-rfq/vendor-rfq-detail-view/:id/"
            element={
              <Suspense fallback={<SpinLoading />}>
                <ViewRFQVendor />
              </Suspense>
            }
          />

          <Route
            path="/forgot-password"
            element={
              <Suspense fallback={<SpinLoading />}>
                <ForgotPassword />
              </Suspense>
            }
          />
          <Route
            path="/mail-sent"
            element={
              <Suspense fallback={<SpinLoading />}>
                <ForgotSuccess />
              </Suspense>
            }
          />
          <Route
            path="/password-success"
            element={
              <Suspense fallback={<SpinLoading />}>
                <PasswordSuccess />
              </Suspense>
            }
          />
          <Route
            path="/verify-success"
            element={
              <Suspense fallback={<SpinLoading />}>
                <VerifySuccess />
              </Suspense>
            }
          />
          <Route
            path="/register-success"
            element={
              <Suspense fallback={<SpinLoading />}>
                <RegisterSuccess />
              </Suspense>
            }
          />
          <Route
            path="/request-success"
            element={
              <Suspense fallback={<SpinLoading />}>
                <RequestSuccess />
              </Suspense>
            }
          />
          <Route
            path="/verify-account"
            element={
              <Suspense fallback={<SpinLoading />}>
                <VerifyAccount />
              </Suspense>
            }
          />
          <Route
            path="/verify/:mode/:id"
            element={
              <Suspense fallback={<SpinLoading />}>
                <VerifyOtp />
              </Suspense>
            }
          />
        </Routes>
      )}
    </>
  );
};

export default Root;
